<template>
    <div>
        <div class="preheat-control" v-show="isConcentrate && isInsert" @click="showConcentrateSetting">
            <span class="concentrate-img"></span>
            <span class="preheat-status">{{(selectedConcentrateType!= null && selectedConcentrateType.id !== -1) ? selectedConcentrateType.pasteTypeName : `Please Select Concentrate Tape`}}</span>
            <span class="right-arrow"></span>
        </div>
        <div class="temperature-mode-container " >

            <div class="mode-name-container" ref="temperatureModeContainer">
                <span class="mode-name">{{isInsert ? currentTemperatureMode.name : ``}}</span> <span class="setting-mode-icon"
                                                                                     @click="showTemperatureSetting"></span>
            </div>
            <span class="mode-tips  mt-8">This thing should only exist in the heaven, such as walking in the clouds.</span>
            <canvas ref="temperatureCanvas" :width="canvasWidth" height="130px"
                    :class="[isInsert ? ``:`hidden-item`]">

            </canvas>

        </div>

    </div>
</template>

<script>
    import TemperatureGraphView from "../repository/TemperatureGraphView"
    import {initCanvasRatio} from "../util/util"

    export default {
        name    : "TemperatureMode",
        props   : {
            isShow         : {
                type   : Boolean,
                default: false
            },
            isFire         : {
                type   : Boolean,
                default: false
            },
            showLine       : {
                type   : Boolean,
                default: false
            },
            temperatureData: {
                type   : Object,
                default: () => {
                    return {}
                }
            },
            isConcentrate  : {
                type   : Boolean,
                default: false
            }
        },
        watch   : {
            isShowChanged(newValue, oldValue) {
                if (newValue) {
                    const canvas = this.$refs.temperatureCanvas
                    if (!this.temperatureGraphView) {
                        const temperatureModeContainer           = this.$refs.temperatureModeContainer
                        const temperatureModeContainerWidthValue = temperatureModeContainer.offsetWidth
                        this.canvasWidth                         = `${temperatureModeContainerWidthValue}px`
                        this.$nextTick(() => {
                            const temperatureModeContainer           = this.$refs.temperatureModeContainer
                            const temperatureModeContainerWidthValue = temperatureModeContainer.offsetWidth
                            this.canvasWidth                         = `${temperatureModeContainerWidthValue}px`

                            if (canvas.getContext) {
                                const canvasObj = initCanvasRatio(canvas)
                                this.viewWidth  = canvasObj.width
                                this.viewHeight = canvasObj.height
                                this.ratio = canvasObj.ratio
                            }


                            this.temperatureGraphView                = new TemperatureGraphView(canvas, this.viewWidth, this.viewHeight,this.ratio)
                            this.temperatureGraphView.init({
                                showLine: this.showLine,
                                data    : this.temperatureData.secondTemperature
                            })
                            this.temperatureGraphView.draw()
                        })
                    } else {
                        this.temperatureGraphView.draw()
                    }
                }

            },
            isFireChanged(newValue, oldValue) {
                if (newValue !== oldValue) {
                    if (newValue) {
                        this.startSwipe()
                    } else {
                        this.stopSwipe()
                    }
                }
            },
            currentTemperatureMode(newValue, oldValue) {
                if (this.temperatureGraphView) {
                    if (newValue.secondTemperature) {
                        this.temperatureGraphView.init({
                            showLine: this.showLine,
                            data    : newValue.secondTemperature
                        })
                        this.temperatureGraphView.draw()
                    }
                }
            }
        },
        computed: {
            isShowChanged() {
                return this.isShow
            },
            isFireChanged() {
                return this.isFire
            },

            temperatureMode() {
                return this.$store.state.temperatureMode

            },
            currentTemperatureMode() {
                return this.temperatureData
            },
            selectedConcentrateType() {
                return this.$store.state.selectedConcentrateType
            },
            isInsert() {
                return this.$store.state.deviceInfo.isInsert
            }
        },
        data() {
            return {
                temperatureGraphView        : null,
                canvasWidth                 : "400px",
                isShowTemperatureModeSetting: false
            }
        },
        methods : {
            startSwipe() {
                if (this.temperatureGraphView) {
                    this.temperatureGraphView.startSwipe()
                }
            },
            stopSwipe() {
                if (this.temperatureGraphView) {
                    this.temperatureGraphView.stopSwipe()
                }
            },

            showTemperatureSetting() {
                this.$emit("showTemperatureSettingChanged", true)
            },

            showConcentrateSetting() {
                this.$emit("showConcentrateSettingChanged", true)
            },

            concentrateTypeClicked() {
                if (this.isConcentrate) {
                }
            }
        },
        mounted() {
            if (this.temperatureGraphView) {
                this.temperatureGraphView.draw()
            }
        },

    }
</script>

<style lang="scss" scoped>
    .preheat-control {
        display: flex;
        flex-direction: row;
        background: #333333;
        padding: 12px;
        font-size: 14px;
        border-radius: 8px;
        align-items: center;
        color: #F6F6F6;

        .preheat-status {
            flex: 1;
            text-align: center;
        }

        .concentrate-img {
            width: 20px;
            height: 18px;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            @include bg-image("../assets/concentrate");
        }

        .right-arrow {
            width: 11px;
            height: 18px;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            @include bg-image("../assets/right-arrow");
        }

    }

    .temperature-mode-container {
        display: flex;
        padding: 22px;
        margin-top: 16px;
        flex-direction: column;
        background-color: #333333;
        border-radius: 16px;

        .mode-name-container {
            display: flex;
            flex-direction: row;
            align-items: center;

            .mode-name {
                flex: 1;
                font-size: 17px;
                color: #ED6C0F;
            }

            .setting-mode-icon {
                width: 18px;
                height: 14px;
                background-repeat: no-repeat;
                background-position: center center;
                background-size: cover;
                @include bg-image("../assets/setting-mode-icon");
            }
        }


        .mode-tips {
            font-size: 10px;
            color: #F6F6F6;
        }
    }
    .hidden-item {
        visibility: hidden;
    }
</style>